module.exports = __webpack_public_path__ + "static/media/Novecentowide-Normal.691ce817.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/font/Novecentowide-Normal.ttf
// module id = 1641
// module chunks = 0